import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

interface ImagenProps {
  prop: string;
}

export const InfoText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  fontWeight: theme.typography.fontWeightBold,
}));

export const InfoContainer = styled('div')(({ theme }) => ({
  ...theme.typography.body1,
  display: 'flex',
  margin: '1.65rem 0',
  [theme.breakpoints.down('sm')]: {
    margin: '1.3rem 0 2.3rem',
  },
}));

export const ImageTitle = styled('div')(({ theme }) => ({
  height: '26.75rem',
  borderRadius: '1rem 1rem 0 0',
  position: 'relative',
  '&:before': {
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    right: '0',
    background: `linear-gradient(to bottom, rgba(0, 0, 0, 0) 31%, #1b3448)`,
  },
  [theme.breakpoints.down('sm')]: {
    width: '95%',
    height: '16.5rem',
    margin: '0 auto',
  },
}));

export const Imagen = styled(Box)<ImagenProps>(({ theme, prop }) => ({
  backgroundImage: `url(${prop})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  width: '100%',
  height: '100%',
  borderRadius: '1rem 1rem 0 0',
}));

export const DateText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  fontSize: '1rem',
  lineHeight: '1.5rem',
  color: 'white',
  textTransform: 'capitalize',
  [theme.breakpoints.down('sm')]: {
    ...theme.typography.body2,
    lineHeight: '1.5rem',
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  ...theme.typography.h5,
  lineHeight: '2.3rem',
  color: 'white',
  fontWeight: 'bold',
  width: '50%',
  [theme.breakpoints.down('sm')]: {
    ...theme.typography.h6,
    lineHeight: '1.4rem',
    width: '80%',
  },
}));

export const Content = styled(Box)(({ theme }) => ({
  border: '1px inside #eef1f3',
  textAlign: 'start',
  boxShadow: theme.customShadows.z24,
  borderRadius: '1.25rem',
  padding: '2.8rem 3rem 3.1rem',
  [theme.breakpoints.down('sm')]: {
    width: '95%',
    margin: '0 auto',
    padding: '2.3rem 1.5rem 2.8rem',
  },
  img: {
    margin: '0 auto',
  },

  '& h1': {
    ...theme.typography.h4,
  },

  '& h2': {
    ...theme.typography.h5,
  },

  '& p': {
    ...theme.typography.body1,
  },

  '& a': {
    ...theme.typography.body1,
    color: theme.palette.primary.main,
  },
}));

export const Text = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  lineHeight: '2rem',
  color: theme.palette.grey[500],
  width: '85%',
  margin: '0 auto',
}));

export const DateContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));

export const CategoriesContainer = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
}));

export const LoadingSkeleton = styled(Skeleton)(() => ({
  height: '26.75rem',
  borderRadius: '1rem 1rem 1rem 1rem',
  margin: '2rem 0 1rem',
}));

export const TitleContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: '2.5rem',
  left: '2rem',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    left: '1rem',
  },
}));
